import { render, staticRenderFns } from "./CrudUnity.vue?vue&type=template&id=7ac17b88&scoped=true&"
import script from "./CrudUnity.vue?vue&type=script&lang=js&"
export * from "./CrudUnity.vue?vue&type=script&lang=js&"
import style0 from "./CrudUnity.vue?vue&type=style&index=0&id=7ac17b88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac17b88",
  null
  
)

export default component.exports